import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OrganisationDto } from '@assetaccountant/api/models/organisation.dto';
import { AssetsService } from '@assetaccountant/assets/services/assets.service';
import { Register } from '@assetaccountant/core';
import { RegimeApiModel } from '@assetaccountant/core/models/regime-api-model';
import { PeriodData, PeriodParams } from '@assetaccountant/core/resolvers/period.resolver';
import { LayoutService } from '@assetaccountant/core/services/layout.service';
import { RouteService } from '@assetaccountant/core/services/route.service';
import { PageHeadingModel, TitleModel } from '@assetaccountant/core/services/title.service';
import {
  getChildRoute,
  TypedActivatedRouteSnapshot,
} from '@assetaccountant/core/utils/route-utils';
import { filter } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  standalone: false,
})
export class HeaderBarComponent implements OnInit, OnChanges {
  @Input() title: TitleModel | null | undefined;

  breadcrumbs: PageHeadingModel[] = [];
  pageHeading = '';

  currentPeriod?: { startDate: string; endDate: string; useFY: boolean };
  currentRegime?: RegimeApiModel;
  currentRegister?: Register;
  currentOrganisation?: OrganisationDto;
  regimes: RegimeApiModel[] = [];
  showCalendarSelector = true;
  showRegimeSelector = true;

  /** Zendesk support link opened by the header help button; configured per environment. */
  get supportUrl(): string {
    return environment.knowledgeBaseUrl;
  }

  assetLink = (id, name): string => {
    return this.routeService.getAssetRoute(id, name);
  };
  moreResultsLink = this.routeService.getAssetsRoute();

  constructor(
    private router: Router,
    public assetsService: AssetsService,
    private layoutService: LayoutService,
    private routeService: RouteService,
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((e: any): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const { organisation, register, regime, period } = getChildRoute(
          this.router.routerState.snapshot.root as TypedActivatedRouteSnapshot<
            PeriodParams,
            PeriodData
          >,
        ).data;

        this.currentOrganisation = organisation?.activeOrganisation;

        this.currentRegister = register;

        this.currentRegime = regime;

        this.currentPeriod = period
          ? {
              ...period,
              useFY: /\/years\//.test(this.router.url),
            }
          : undefined;
      });

    this.layoutService.showCalendarSelector.subscribe(s => {
      setTimeout(() => {
        this.showCalendarSelector = s;
      }, 0);
    });

    this.layoutService.showRegimeSelector.subscribe(s => {
      setTimeout(() => {
        this.showRegimeSelector = s;
      }, 0);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('title' in changes) {
      if (!this.title?.pageHeading || this.title.pageHeading.length === 0) {
        this.breadcrumbs = [];
        this.pageHeading = this.title?.pageTitle || '';
      } else {
        this.breadcrumbs = this.title.pageHeading.slice(0, -1);

        // Prepend register segment unless specified to hide
        if (!this.title.hideRegisterSegment && this.currentRegister) {
          this.breadcrumbs.unshift({
            name: this.currentRegister.name,
            route: '/organisations/-/registers/-/',
          });
        }

        // Prepend ogranisation segment
        if (this.currentOrganisation) {
          this.breadcrumbs.unshift({
            name: this.currentOrganisation.name,
            route: '/organisations/-/dashboard',
          });
        }

        this.pageHeading = this.title.pageHeading[this.title.pageHeading.length - 1].name;
      }
    }
  }
}
